import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#5f6368",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M440-760v-160h80v160zm266 110-56-56 113-114 56 57zm54 210v-80h160v80zm3 299L650-254l56-56 114 112zM254-650 141-763l57-57 112 114zm-14 450h180q25 0 42.5-17.5T480-260t-17-42.5-42-17.5h-51l-20-48q-14-33-44-52.5T240-440q-50 0-85 35t-35 85 35 85 85 35m0 80q-83 0-141.5-58.5T40-320t58.5-141.5T240-520q60 0 109.5 32.5T423-400q58 0 97.5 43T560-254q-2 57-42.5 95.5T420-120zm320-134q-5-20-10-39t-10-39q45-19 72.5-59t27.5-89q0-66-47-113t-113-47q-60 0-105 39t-53 99q-20-5-41-9t-41-9q14-88 82.5-144T480-720q100 0 170 70t70 170q0 77-44 138.5T560-254m-79-226" }, null, -1)
  ])))
}
export default { render: render }